import loadable from '@loadable/component';
import CreateIcon from '../../Icons/CreateIcon';
import StatusIcon from '../../Icons/StatusIcon';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import InvoiceIcon from '../../Icons/InvoiceIcon';
const InvoiceComponent = loadable(() => import('../../components/Invoice'));
const InvoiceList = () => {
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <InvoiceIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Statement List
        </span>
      </div>
      <InvoiceComponent />
    </>
  );
};

export default InvoiceList;
